import { allExceptions } from "../fixtures/allExceptions.ts";

const defaultException = "A ocurrido un error";

export const getExceptionMessage = (
  code: any,
  defaultMessage = defaultException,
): string => {
  if (!code) return defaultMessage;

  return allExceptions[code] || defaultMessage;
};
